import React, { Component, Fragment } from 'react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'redux'
import { connect } from 'react-redux'
import cn from 'classnames'
import Dialog from 'react-toolbox/lib/dialog'
import T from 'i18n-react'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import Divider from 'components/fulcrum/divider/Divider'
import {
  Table,
  TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import {
  activeSelector,
  hierarchySelector,
  projectsSelector,
  searchSelector,
  hierarchyTypeSourceSelector,
  projectsSourceSelector
} from './selectors'
import {
  openDialog,
  closeDialog,
  addProject,
  removeProject,
  updateHierarchyType,
  fetchProjectsSearch,
  postHierarchies,
  updateComments
} from './actions'
import {
  MODULE_NAME,
  HIERARCHIES_OPTIONS
} from './constants'
import injectSagas from 'helpers/injectSagas'
import Sagas from './sagas'
import { Link } from 'react-router-dom'
import Select from 'react-select';
import { IconButton } from 'react-toolbox/lib/button'
import { projectIdSelector } from 'containers/Project/View/selectors'
import { Flex } from 'reflexbox'
import Input from 'components/fulcrum/input/Input'
import { getMonthDateYearTimestampString  } from 'helpers/DateUtil'

const mapStateToProps = (state) => {
  return {
    active: activeSelector(state),
    hierarchy: hierarchySelector(state),
    projects: projectsSelector(state),
    search: searchSelector(state),
    id: projectIdSelector(state),
    hierarchySource: hierarchyTypeSourceSelector(state),
    projectsSource: projectsSourceSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openDialog: () => dispatch(openDialog()),
    closeDialog: () => dispatch(closeDialog()),
    addProject: (project, hierarchyType) => dispatch(addProject(project, hierarchyType)),
    removeProject: (id) => dispatch(removeProject(id)),
    updateHierarchyType: (value) => dispatch(updateHierarchyType(value)),
    fetchProjectsSearch: (query) => dispatch(fetchProjectsSearch(query)),
    postHierarchies: (payload) => dispatch(postHierarchies(payload)),
    updateComments: (id, comments) => dispatch(updateComments(id, comments))
  }
}

class EditDialog extends Component {

  processupdateHierarchyType = (newHierarchy) => {
    if (newHierarchy !== this.props.hierarchy) {
      this.props.updateHierarchyType(newHierarchy)
    }
  }

  processAddProject = (project) => {
    const { 
      hierarchy, 
      addProject 
    } = this.props
    addProject(project, hierarchy)
  }

  processUpdateComments = (id, comments) => {
    this.props.updateComments(id, comments)
  }

  componentDidMount() {
  }

  onDelete = (id) => {
    this.props.removeProject(id)
  }

  onSave = () => {
    const {
      id,
      hierarchy,
      projects,
      postHierarchies
    } = this.props
    postHierarchies({
      projectId: parseInt(id),
      hierarchyType: hierarchy,
      projects: projects.map(({id, comments}) => ({ id, comments }))
    })
  }

  warningCheck = (project) => {
    const { hierarchy } = this.props
    if (hierarchy === 'leveraged' && project.leveragedProjects.length > 0){
      return 'hasLeveraged'
    } else if (project.leveragedProjects.length > 0) {
      return 'hasLeveraged'
    } else if (project.primaryProject) {
      return 'hasPrimary'
    }
    return 'pass'
  }

  renderWarning = (project) => {
    const { id, hierarchy, hierarchySource } = this.props
    const sourceProjId = parseInt(id)
    const checkString = this.warningCheck(project)
    const alreadyAdded = (project.leveragedProjects.includes(sourceProjId) || (sourceProjId === project.primaryProject)) && hierarchySource === hierarchy
    if (alreadyAdded || checkString === 'pass') return

    const projId = checkString === 'hasLeveraged' ? project.leveragedProjects[0] : project.primaryProject
    const str = checkString === 'hasLeveraged' && project.leveragedProjects.length > 1 ? 'hasLeveragedMultiple' : checkString
    return(
      <div className={styles.warningMsg}>
        {T.translate(`project.hierarchies.dialog.eligibility.${str}`, { id: projId, cnt: project.leveragedProjects.length - 1 })}
      </div>
    )
  }

  renderTableHead = () => { 
    return(
    <TableHead key={`head`} className={styles.row} >
      <TableCell key={`projectIdHead`}>Project ID</TableCell>
      <TableCell key={`nameHead`}>Name</TableCell>
      <TableCell key={`skuHead`}>SKU</TableCell>
      <TableCell key={`aerHead`}>AE Resource Level</TableCell>
      <TableCell key={`usertimeHead`}>Last Updated</TableCell>
      <TableCell key={`commentsHead`}>Comments</TableCell>
      <TableCell styleName={"deleteCol"} key={`removeHead`}>Delete</TableCell>
    </TableHead>
  )}


  renderTableRows = () => {
    const {
      projects,
    } = this.props

    return projects.map((proj) => {
      const {
        id,
        name,
        sku,
        aeResourceLevel,
        user,
        time,
        comments
      } = proj
      return (
      <TableRow key={`row${id}`} className={styles.row} >
        <TableCell key={`projectId${id}`}>
          <Link to={`/project/${id}/view`} target="_blank">{id}</Link>
        </TableCell>
        <TableCell key={`name${id}`}>
          <div>
            <div>{name}</div>
            <div>{this.renderWarning(proj)}</div>
          </div>
        </TableCell>
        <TableCell key={`sku${id}`}>
          <div>{sku}</div>
        </TableCell>
        <TableCell key={`aer${id}`}>
          <div>{aeResourceLevel}</div>
        </TableCell>
        <TableCell key={`usertime${id}`}>
          <div>{user && <Fragment><div>{user}</div><div>{getMonthDateYearTimestampString(new Date(time))}</div></Fragment>}</div>
        </TableCell>
        <TableCell key={`comment${id}`}>
          <Input
            type='text'
            value={comments}
            onChange={this.processUpdateComments.bind(this, id)}
            hint={'Add a comment...'}
          />
        </TableCell>
        <TableCell key={`icondelete${id}`}>
          <IconButton icon={'delete'} theme={styles} onClick={this.onDelete.bind(this, id)}/>
        </TableCell>
    </TableRow>
    )})
  }

  renderHierarchyTypeDropdown = () => {
    const { hierarchy, hierarchySource, projectsSource } = this.props
    const hierarchyChangeWarning = hierarchy !== hierarchySource && projectsSource.length > 0
    return(
      <div styleName='hierarchyType'>
            <div>Project Type</div>
            <Flex className={styles.hierarchyTypeWrapper}>
              <Dropdown value={this.props.hierarchy} source={HIERARCHIES_OPTIONS} onChange={this.processupdateHierarchyType} className={styles.typeDropdown} />
              {hierarchyChangeWarning && <div className={cn(styles.warningMsg, styles.hierarchyTypeWarningMsg)}>{T.translate(`project.hierarchies.dialog.hierarchyChange`)}</div>}
            </Flex>
      </div>
    )
  }

  renderSearchDropdown = () => {
    const { 
      search,
      hierarchy,
      fetchProjectsSearch, 
    } = this.props
    return(
      <div styleName='searchWrapper'>
      <div>{T.translate(`project.hierarchies.dialog.instruction.${hierarchy}`)}</div>
          <Select
            placeholder={"Begin by typing project ID or name..."}
            onInputChange={fetchProjectsSearch}
            options={search}
            onChange={this.processAddProject}
            noResultsText={'Type something, or try a different query'}
            menuContainerStyle={{ zIndex: 5 }}
          />
    </div>
    )
  }

  renderEmptyMsg = () => {
    return(<Flex className={styles.emptySelectionMsg}>
      No projects are added yet
    </Flex>)
  }

  renderTable = () => {
    return (
      <div styleName='tableWrapper'>
      {this.props.projects.length === 0 ? 
        this.renderEmptyMsg() : 
        <Table
          selectable={false}
          className={styles.table}
        >
          {this.renderTableHead()}
          {this.renderTableRows()}
        </Table>
      }
      </div>
    )
  }

  render() {

    const {
      active,
      hierarchy,
      closeDialog,
      projects,
    } = this.props

    const saveDisabled = hierarchy === 'leveraged' && projects.length === 0

    return (
      <Dialog
      active={active}
      title={T.translate('project.hierarchies.dialog.title')}
      actions={[{label: "Cancel" , onClick: closeDialog }, {label: "Save", disabled: saveDisabled, onClick: this.onSave }]}
      onOverlayClick={closeDialog}
      onEscKeyDown={closeDialog}
      className={styles.dialog}
      >
        <div styleName='container'>
          <Divider styleName='topDivider'/>
          {this.renderHierarchyTypeDropdown()}
          {this.renderSearchDropdown()}
          {this.renderTable()}
        </div>
      </Dialog>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ [MODULE_NAME]: Sagas })

const withStyles = CSSModules(styles)
const enhance = compose(
  withConnect,
  withSagas,
  withStyles,
)

export default enhance(EditDialog)
